import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import axios from "axios";
import { forceRound, formatDateToTime, formatDateToTimeStampte, getLowerCaseString, loadCss, localize } from "../../helpers/function";
import LoadingTable from "../components/LoadingTable";
import appConfig from "../../config/appConfig";
import Pagination from "../components/Pagination";
import EmptyTable from "../components/EmptyTable";
import HeaderTablePage from "../components/HeaderTablePage";
import { ERROR_401 } from "../../config/errorPage";
import { verifyPermission } from "../../helpers/permission";

import { NUMBER_ELEMENT_PER_PAGE } from "../../constants/dataTable";
import { verifyTokenExpire } from "../../middleware/verifyToken";
import { ToastBottomEnd } from "../components/Toast";
import {
  toastDeleteSuccessMessageConfig,
  toastSuccessMessageWithParameterConfig,
} from "../../config/toastConfig";
import { useTranslation } from "react-i18next";
import moment from "moment";
import FileSaver from "file-saver";

loadCss("/assets/plugins/custom/datatables/datatables.bundle.css");

const ProofReceipt = (props) => {
  //usage of useTranslation i18n
  const { t, ready } = useTranslation();

  if (
    !(
      verifyPermission(props.userPermissions, "list-notification-proof") ||
      verifyPermission(props.userPermissions, "list-any-notification-proof") ||
      verifyPermission(
        props.userPermissions,
        "pilot-list-notification-proof"
      ) ||
      verifyPermission(
        props.userPermissions,
        "pilot-list-any-notification-proof"
      )
    )
  )
    window.location.href = ERROR_401;

  let endPoint = "";
  if (
    verifyPermission(props.userPermissions, "list-notification-proof") ||
    verifyPermission(props.userPermissions, "pilot-list-notification-proof")
  )
    endPoint = "/my/notifications/proofs";
  else if (
    verifyPermission(props.userPermissions, "list-any-notification-proof") ||
    verifyPermission(props.userPermissions, "pilot-list-any-notification-proof")
  )
    endPoint = "/notifications/proofs";

  const [load, setLoad] = useState(true);
  const [staffs, setProofs] = useState([]);
  const [numberPerPage, setNumberPerPage] = useState(NUMBER_ELEMENT_PER_PAGE);
  const [activeNumberPage, setActiveNumberPage] = useState(1);
  const [numberPage, setNumberPage] = useState(0);
  const [showList, setShowList] = useState([]);
  const defautFilterDataError = {
    sender: [],
    chanel: [],
    start_date: [],
    end_date: [],
  };
  const [errorFilterData, setErrorFilterData] = useState(defautFilterDataError);
  const [filterData, setFilterData] = useState({
    sender: "",
    chanel: "",
    start_date: moment().startOf("month").format("YYYY-MM-DD"),
    end_date: moment().endOf("month").format("YYYY-MM-DD"),
  });
  const [startFilter, setStartFilter] = useState(false);
  const [expeditors, setExpeditors] = useState([]);
  const [expeditor, setExpeditor] = useState(null);
  const [total, setTotal] = useState(0);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [responseChannels, setResponseChannels] = useState([]);
  const getProofsPayload = (responseData = {}) => {
    const payload = responseData?.proofs || responseData;
    return {
      data: Array.isArray(payload?.data) ? payload.data : [],
      total:
        typeof payload?.total === "number"
          ? payload.total
          : Array.isArray(payload?.data)
            ? payload.data.length
            : 0,
      prev_page_url:
        payload?.prev_page_url !== undefined ? payload.prev_page_url : null,
      next_page_url:
        payload?.next_page_url !== undefined ? payload.next_page_url : null,
    };
  };
  const sendData = {
    channel: filterData.chanel,
    date_start: filterData.start_date,
    date_end: filterData.end_date,
    institution_id: expeditor ? expeditor.value : "",
  };
  const [loadDownloadPdf, setLoadDownloadPdf] = useState(false);
  const normalizeMessageContent = (rawMessage) => {
    if (!rawMessage || typeof rawMessage !== "string") return "";

    // Fix common mojibake case where UTF-8 bytes were read as Latin-1 (e.g. "rÃ©clamation").
    const tryFixMojibake = (value) => {
      try {
        const bytes = Uint8Array.from(
          Array.from(value).map((char) => char.charCodeAt(0))
        );
        return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
      } catch (error) {
        return value;
      }
    };

    const maybeFixedMessage =
      /Ã.|Â.|â.|Ê|Ô|Û|î|ï/.test(rawMessage) ? tryFixMojibake(rawMessage) : rawMessage;

    // Convert HTML to readable text (removes tags and decodes entities).
    if (typeof window !== "undefined" && window.document) {
      const container = window.document.createElement("div");
      container.innerHTML = maybeFixedMessage;
      return (container.textContent || "").trim();
    }

    return maybeFixedMessage.replace(/<[^>]*>/g, "").trim();
  };

  if (!sendData.channel) delete sendData.channel;
  if (!sendData.date_start) delete sendData.date_start;
  if (!sendData.date_end) delete sendData.date_end;
  if (!sendData.institution_id) delete sendData.institution_id;
  let endPointi = appConfig.apiDomaine + endPoint;

  // Fetch response-channels data
  useEffect(() => {
    axios.get(appConfig.apiDomaine + "/response-channels")
      .then((response) => {
        setResponseChannels(response.data);
      })
      .catch((error) => {
        console.error("Error fetching response-channels:", error);
      });
  }, [appConfig.apiDomaine]);

  useEffect(() => {
    async function fetchData() {
      await axios
        .post(endPointi + "?page=1&size=" + numberPerPage, sendData)
        .then((response) => {
          const tempProofs = getProofsPayload(response.data);
          setActiveNumberPage(1);
          setLoad(false);
          if (
            verifyPermission(
              props.userPermissions,
              "list-notification-proof"
            ) ||
            verifyPermission(
              props.userPermissions,
              "pilot-list-notification-proof"
            )
          ) {
            if (tempProofs.data.length === 0) {
              setNumberPage(forceRound(0 / numberPerPage));
              setShowList([]);
              setProofs([]);
              setTotal(0);
              setPrevUrl(tempProofs.prev_page_url);
              setNextUrl(tempProofs.next_page_url);
            } else {
              // console.log("tempProofs", tempProofs);
              setNumberPage(forceRound(tempProofs.total / numberPerPage));
              setShowList(tempProofs.data.slice(0, numberPerPage));
              setProofs(tempProofs.data);
              setTotal(tempProofs.total);
              setPrevUrl(tempProofs.prev_page_url);
              setNextUrl(tempProofs.next_page_url);
            }
          } else if (
            verifyPermission(
              props.userPermissions,
              "list-any-notification-proof"
            ) ||
            verifyPermission(
              props.userPermissions,
              "pilot-list-any-notification-proof"
            )
          ) {
            setExpeditors(
              (response.data["filter-data"] || []).map((item) => {
                return {
                  value: item.id,
                  label: item.name,
                };
              })
            );
            setNumberPage(
              forceRound(tempProofs.total / numberPerPage)
            );
            setShowList(tempProofs.data.slice(0, numberPerPage));
            setProofs(tempProofs.data);
            setPrevUrl(tempProofs.prev_page_url);
            setNextUrl(tempProofs.next_page_url);
            setLoad(false);
          }
        })
        .catch((error) => {
          setLoad(false);
        });
    }
    if (verifyTokenExpire()) fetchData();
  }, [endPointi, numberPerPage]);

  const searchElement = async (e) => {
    if (e.target.value) {
      if (verifyTokenExpire()) {
        setLoad(true);
        axios
          .post(
            endPointi +
            "?key=" +
            getLowerCaseString(e.target.value) +
            "&size=" +
            numberPerPage,
            sendData
          )
          .then((response) => {
            const tempProofs = getProofsPayload(response.data);
            setLoad(false);
            setProofs(tempProofs.data);
            setShowList(tempProofs.data.slice(0, numberPerPage));
            setTotal(tempProofs.total);
            setNumberPage(forceRound(tempProofs.total / numberPerPage));
            setPrevUrl(tempProofs.prev_page_url);
            setNextUrl(tempProofs.next_page_url);
          })
          .catch((error) => {
            setLoad(false);
          });
      }
    } else {
      /*            setNumberPage(forceRound(claimsArchived.length / NUMBER_ELEMENT_PER_PAGE));
            setShowList(claimsArchived.slice(0, NUMBER_ELEMENT_PER_PAGE));*/
      if (verifyTokenExpire()) {
        setLoad(true);
        axios
          .post(endPointi + "?size=" + numberPerPage, sendData)
          .then((response) => {
            const tempProofs = getProofsPayload(response.data);
            setLoad(false);
            setProofs(tempProofs.data);
            setShowList(tempProofs.data.slice(0, numberPerPage));
            setTotal(tempProofs.total);
            setNumberPage(forceRound(tempProofs.total / numberPerPage));
            setPrevUrl(tempProofs.prev_page_url);
            setNextUrl(tempProofs.next_page_url);
          })
          .catch((error) => {
            setLoad(false);
          });
      }
      setActiveNumberPage(1);
    }
  };

  const onChangeNumberPerPage = (e) => {
    e.persist();
    const nextSize = parseInt(e.target.value);
    if (verifyTokenExpire()) {
      setLoad(true);
      axios
        .post(endPointi + "?size=" + nextSize, sendData)
        .then((response) => {
          const tempProofs = getProofsPayload(response.data);
          setLoad(false);
          setActiveNumberPage(1);
          setNumberPage(forceRound(tempProofs.total / nextSize));
          setShowList(tempProofs.data.slice(0, nextSize));
          setProofs(tempProofs.data);
          setTotal(tempProofs.total);
          setPrevUrl(tempProofs.prev_page_url);
          setNextUrl(tempProofs.next_page_url);

        })
        .catch((error) => {
          setLoad(false);
        });
    }
    setNumberPerPage(nextSize);
  };

  const onClickPage = (e, page) => {
    e.preventDefault();
    setActiveNumberPage(page);
    // console.log(endPoint);
    if (verifyTokenExpire()) {
      setLoad(true);
      axios
        .post(endPointi + "?page=" + page + "&size=" + numberPerPage, sendData)
        .then((response) => {
          const tempProofs = getProofsPayload(response.data);
          setLoad(false);
          // setNumberPage(
          //   forceRound(response.data.proofs.data.length / NUMBER_ELEMENT_PER_PAGE)
          // );
          setActiveNumberPage(page);
          setShowList(tempProofs.data.slice(0, numberPerPage));
          setProofs(tempProofs.data);
          setNumberPage(forceRound(tempProofs.total / numberPerPage));
          setTotal(tempProofs.total);
          setPrevUrl(tempProofs.prev_page_url);
          setNextUrl(tempProofs.next_page_url);

        })
        .catch((error) => {
          setLoad(false);
        });
    }
  };

  const onClickNextPage = (e) => {
    e.preventDefault();
    if (activeNumberPage < numberPage) {
      if (nextUrl !== null) {
        if (verifyTokenExpire()) {
          const nextRequestUrl = nextUrl.includes("?")
            ? `${nextUrl}&size=${numberPerPage}`
            : `${nextUrl}?size=${numberPerPage}`;
          setLoad(true);
          axios
            .post(nextRequestUrl, sendData)
            .then((response) => {
              const tempProofs = getProofsPayload(response.data);
              setLoad(false);
              // setNumberPage(
              //   forceRound(response.data.proofs.data.length / NUMBER_ELEMENT_PER_PAGE)
              // );
              setShowList(tempProofs.data.slice(0, numberPerPage));
              setProofs(tempProofs.data);
              setNumberPage(forceRound(tempProofs.total / numberPerPage));
              setTotal(tempProofs.total);
              setPrevUrl(tempProofs.prev_page_url);
              setNextUrl(tempProofs.next_page_url);
              setActiveNumberPage((prevPage) => prevPage + 1);
            })
            .catch((error) => {
              setLoad(false);
            });
        }
      }
    }
  };

  const onClickPreviousPage = (e) => {
    e.preventDefault();
    if (activeNumberPage > 1) {
      if (prevUrl !== null) {
        if (verifyTokenExpire()) {
          const previousRequestUrl = prevUrl.includes("?")
            ? `${prevUrl}&size=${numberPerPage}`
            : `${prevUrl}?size=${numberPerPage}`;
          setLoad(true);
          axios
            .post(previousRequestUrl, sendData)
            .then((response) => {
              const tempProofs = getProofsPayload(response.data);
              setLoad(false);
              // setNumberPage(
              //   forceRound(response.data.proofs.data.length / NUMBER_ELEMENT_PER_PAGE)
              // );
              
              setShowList(tempProofs.data.slice(0, numberPerPage));
              setProofs(tempProofs.data);
              setNumberPage(forceRound(tempProofs.total / numberPerPage));
              setTotal(tempProofs.total);
              setPrevUrl(tempProofs.prev_page_url);
              setNextUrl(tempProofs.next_page_url);
              setActiveNumberPage((prevPage) => prevPage - 1);
            })
            .catch((error) => {
              setLoad(false);
            });
        }
      }
    }
  };

  const arrayNumberPage = () => {
    const pages = [];
    // console.log(numberPage);
    for (let i = 0; i < numberPage; i++) {
      pages[i] = i;
    }
    return pages;
  };

  var pages = arrayNumberPage();

  useEffect(() => {
    pages = arrayNumberPage();
  }, [numberPage]);

  const printBodyTable = (proof, index) => {
    return (
      <tr key={index} role="row" className="odd">
        {(verifyPermission(
          props.userPermissions,
          "list-any-notification-proof"
        ) ||
          verifyPermission(
            props.userPermissions,
            "pilot-list-any-notification-proof"
          )) && <td>{proof.institution ? proof.institution.name : ""}</td>}
        <td>
          {proof.to
            ? `${proof.to.firstname ? proof.to.firstname : ""} ${proof.to.lastname ? proof.to.lastname : ""
            }`
            : ""}{" "}
          /{" "}
          {proof.to
            ? proof.channel === "sms"
              ? `${proof.to.telephone && proof.to.telephone[0]
                ? proof.to.telephone[0]
                : ""
              }`
              : `${proof.to.email && proof.to.email[0] ? proof.to.email[0] : ""
              }`
            : ""}
        </td>
        <td>{proof.channel ? proof.channel : ""}</td>
        <td
          className="text-wrap"
          style={{
            maxWidth: "200px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          title={normalizeMessageContent(proof.message)}
        >
          {normalizeMessageContent(proof.message)}
        </td>
        <td>{proof.sent_at ? formatDateToTimeStampte(proof.sent_at) : ""}</td>
        <td>{proof.status ? proof.status : ""}</td>
      </tr>
    );
  };

  const handleChange = (e) => {
    const newFilterData = { ...filterData };
    switch (e.target.id) {
      case "sender":
        newFilterData.sender = e.target.value;
        break;
      case "chanel":
        newFilterData.chanel = e.target.value;
        break;
      case "start_date":
        newFilterData.start_date = e.target.value;
        break;
      case "end_date":
        newFilterData.end_date = e.target.value;
        break;
    }
    setFilterData(newFilterData);
  };

  const filterProofReceipt = async () => {
    setStartFilter(true);

    const sendData = {
      channel: filterData.chanel,
      date_start: filterData.start_date,
      date_end: filterData.end_date,
      institution_id: expeditor ? expeditor.value: "",
    };
    if (!sendData.channel) delete sendData.channel;
    if (!sendData.date_start) delete sendData.date_start;
    if (!sendData.date_end) delete sendData.date_end;
    if (!sendData.institution_id) delete sendData.institution_id;

    await axios
      .post(appConfig.apiDomaine + endPoint + "?size=" + numberPerPage, sendData)
      .then((response) => {
        const tempProofs = getProofsPayload(response.data);
        if (
          verifyPermission(
            props.userPermissions,
            "list-any-notification-proof"
          ) ||
          verifyPermission(
            props.userPermissions,
            "pilot-list-any-notification-proof"
          )
        ) {

          setNumberPage(
            forceRound(tempProofs.total / numberPerPage)
          );
          setShowList(tempProofs.data.slice(0, numberPerPage));
          setProofs(tempProofs.data);
          setTotal(tempProofs.total);
          setPrevUrl(tempProofs.prev_page_url);
          setNextUrl(tempProofs.next_page_url);

          ToastBottomEnd.fire(
            toastSuccessMessageWithParameterConfig(t("Succès de l'opération"))
          );
          setErrorFilterData(defautFilterDataError);
        }

        if (
          verifyPermission(props.userPermissions, "list-notification-proof") ||
          verifyPermission(
            props.userPermissions,
            "pilot-list-notification-proof"
          )
        ) {

          setNumberPage(
            forceRound(tempProofs.total / numberPerPage)
          );
          setShowList(tempProofs.data.slice(0, numberPerPage));
          setProofs(tempProofs.data);
          setTotal(tempProofs.total);
          setPrevUrl(tempProofs.prev_page_url);
          setNextUrl(tempProofs.next_page_url);

          ToastBottomEnd.fire(
            toastSuccessMessageWithParameterConfig(t("Succès de l'opération"))
          );
          setErrorFilterData(defautFilterDataError);
        }
      })
      .catch((error) => {
        if (error.response.status === 422) {
          const errorData = error.response.data.error;
          setErrorFilterData({
            ...defautFilterDataError,
            end_date: errorData.date_end ? errorData.date_end : [],
            start_date: errorData.date_start ? errorData.date_start : [],
            chanel: errorData.channel ? errorData.channel : [],
            sender: errorData.institution_id ? errorData.institution_id : [],
          });
        }
      })
      .finally(() => {
        setStartFilter(false);
      });
  };

  const downloadReportingPdf = async () => {
    setLoadDownloadPdf(true);
    const sendData = {
      channel: filterData.chanel,
      date_start: filterData.start_date,
      date_end: filterData.end_date,
      institution_id: expeditor ? expeditor.value : "",
    };
    if (!sendData.channel) delete sendData.channel;
    if (!sendData.date_start) delete sendData.date_start;
    if (!sendData.date_end) delete sendData.date_end;
    if (!sendData.institution_id) delete sendData.institution_id;
    await axios
      .post(appConfig.apiDomaine + "/my/export/notifications/proofs", sendData, {
        responseType: "blob",
      })
      .then((response) => {
        // console.log("Sending data:", sendData);
        // console.log("Request URL:", appConfig.apiDomaine + "/my/export/notifications/proofs");

        // Convert string to Blob if data is a string
        let blob;
        if (typeof response.data === 'string') {
          // Create a Blob from the PDF string with proper MIME type
          blob = new Blob([response.data], { type: 'application/pdf' });
        } else {
          // If it's already a Blob, use it directly
          blob = response.data;
        }
        
        FileSaver.saveAs(
          blob,
          // `proof_of_receipt_${new Date().getFullYear()}.pdf`
          `reporting_retard_30_jours_${new Date().getFullYear()}.pdf`,
          {
            autoBom: true,
          }
        );
        setLoadDownloadPdf(false);
      })
      .catch((error) => {
        setLoadDownloadPdf(false);
        // console.log("Something is wrong", error);
        if (error?.response?.status === 422) {
          const errorData = error.response.data.error;
          setErrorFilterData({
            ...defautFilterDataError,
            end_date: errorData.date_end ? errorData.date_end : [],
            start_date: errorData.date_start ? errorData.date_start : [],
            chanel: errorData.channel ? errorData.channel : [],
            sender: errorData.institution_id ? errorData.institution_id : [],
          });
        }
      })
      .finally(() => {
        setStartFilter(false);
      });
  };

  return ready ? (
    verifyPermission(props.userPermissions, "list-notification-proof") ||
      verifyPermission(props.userPermissions, "list-any-notification-proof") ||
      verifyPermission(props.userPermissions, "pilot-list-notification-proof") ||
      verifyPermission(
        props.userPermissions,
        "pilot-list-any-notification-proof"
      ) ? (
      <div
        className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
        id="kt_content"
      >
        <div className="kt-subheader   kt-grid__item" id="kt_subheader">
          <div className="kt-container  kt-container--fluid ">
            <div className="kt-subheader__main">
              <h3 className="kt-subheader__title">{t("Paramètres")}</h3>
              <span className="kt-subheader__separator kt-hidden" />
              <div className="kt-subheader__breadcrumbs">
                <a href="#icone" className="kt-subheader__breadcrumbs-home">
                  <i className="flaticon2-shelter" />
                </a>
                <span className="kt-subheader__breadcrumbs-separator" />
                <a
                  href="#button"
                  onClick={(e) => e.preventDefault()}
                  className="kt-subheader__breadcrumbs-link"
                  style={{ cursor: "text" }}
                >
                  {t("Preuve d'accusé de réception")}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
          <div className="kt-portlet">
            <HeaderTablePage
              addPermission={[]}
              title={t("Preuve d'accusé de réception")}
            />
            <div className="px-4 pt-2">
              <div className="row">
                {(verifyPermission(
                  props.userPermissions,
                  "list-any-notification-proof"
                ) ||
                  verifyPermission(
                    props.userPermissions,
                    "pilot-list-any-notification-proof"
                  )) && (
                    <div className="form-group col-6">
                      <label htmlFor="sender">{t("Expéditeur")}</label>
                      <Select
                        isClearable={true}
                        placeholder={t("Veuillez sélectionner l'expéditeur")}
                        onChange={(value) => setExpeditor(value)}
                        options={expeditors}
                        value={expeditor}
                      />
                      {errorFilterData.sender.length > 0 &&
                        errorFilterData.sender.map((item, index) => (
                          <div key={index} className="text-danger text-sm">
                            {item}
                          </div>
                        ))}
                    </div>
                  )}

                <div
                  className={`form-group ${verifyPermission(
                    props.userPermissions,
                    "list-any-notification-proof"
                  ) ||
                      verifyPermission(
                        props.userPermissions,
                        "pilot-list-any-notification-proof"
                      )
                      ? "col-6"
                      : "col-12"
                    }`}
                >
                  <label htmlFor="chanel">{t("Canal")}</label>
                  <select
                    id="chanel"
                    className={`form-control ${errorFilterData.chanel.length ? "is-invalid" : ""
                      }`}
                    onChange={handleChange}
                    value={filterData.chanel}
                  >
                    <option disabled selected value={""}>
                      {t("Choisissez")}...
                    </option>
                    {responseChannels.map((channel) => (
                      <option key={channel.id} value={channel.slug}>
                        {localize(channel.name)}
                      </option>
                    ))}
                  </select>
                  {errorFilterData.chanel.length > 0 &&
                    errorFilterData.chanel.map((item, index) => (
                      <div key={index} className="invalid-feedback">
                        {item}
                      </div>
                    ))}
                </div>

                <div className="form-group col-6">
                  <label htmlFor="start_date">{t("Date de début")}</label>
                  <input
                    id="start_date"
                    type="date"
                    className={`form-control ${errorFilterData.start_date.length ? "is-invalid" : ""
                      }`}
                    value={filterData.start_date}
                    onChange={handleChange}
                  />

                  {errorFilterData.start_date.length > 0 &&
                    errorFilterData.start_date.map((item, index) => (
                      <div key={index} className="invalid-feedback">
                        {item}
                      </div>
                    ))}
                </div>
                <div className="form-group col-6">
                  <label htmlFor="end_date">{t("Date de fin")}</label>
                  <input
                    id="end_date"
                    type="date"
                    className={`form-control ${errorFilterData.end_date.length ? "is-invalid" : ""
                      }`}
                    value={filterData.end_date}
                    onChange={handleChange}
                  />
                  <div className="invalid-feedback">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                    Distinctio, fugit!
                  </div>
                  {errorFilterData.end_date.length > 0 &&
                    errorFilterData.end_date.map((item, index) => (
                      <div key={index} className="invalid-feedback">
                        {item}
                      </div>
                    ))}
                </div>

                <div className="form-group text-right col-12">
                  {startFilter ? (
                    <button className="btn btn-brand kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light">
                      {t("Chargement")}...
                    </button>
                  ) : (
                    <button
                      onClick={filterProofReceipt}
                      className="btn btn-primary"
                    >
                      {t("Filtre")}
                    </button>
                  )}

                  {verifyPermission(
                    props.userPermissions,
                    "pilot-export-notification-proof"
                  ) ||
                    verifyPermission(
                      props.userPermissions,
                      "export-notification-proof"
                    ) ? (
                    loadDownloadPdf ? (
                      <button
                        className="btn btn-secondary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--dark ml-3"
                        type="button"
                        disabled
                      >
                        Chargement...
                      </button>
                    ) : (
                      <button
                        onClick={downloadReportingPdf}
                        className="btn btn-secondary ml-3"
                      >
                        PDF
                      </button>
                    )
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 text-left">
                  <div id="kt_table_1_filter" className="dataTables_filter">
                    <label>
                      {t("Recherche")}:
                      <input
                        id="myInput"
                        type="text"
                        onKeyUp={(e) => searchElement(e)}
                        className="form-control form-control-sm"
                        placeholder=""
                        aria-controls="kt_table_1"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {load ? (
              <LoadingTable />
            ) : (
              <div className="kt-portlet__body">
                <div
                  id="kt_table_1_wrapper"
                  className="dataTables_wrapper dt-bootstrap4"
                >
                  <div className="row">
                    <div className="col-sm-12">
                      <table
                        className="table table-striped table-bordered table-hover table-checkable dataTable dtr-inline"
                        id="myTable"
                        role="grid"
                        aria-describedby="kt_table_1_info"
                        style={{ width: "952px" }}
                      >
                        <thead>
                          <tr role="row">
                            {(verifyPermission(
                              props.userPermissions,
                              "list-any-notification-proof"
                            ) ||
                              verifyPermission(
                                props.userPermissions,
                                "pilot-list-any-notification-proof"
                              )) && (
                                <th
                                  className="sorting"
                                  tabIndex="0"
                                  aria-controls="kt_table_1"
                                  rowSpan="1"
                                  colSpan="1"
                                  style={{ width: "70.25px" }}
                                  aria-label="Country: activate to sort column ascending"
                                >
                                  {t("Expéditeur")}
                                </th>
                              )}
                            <th
                              className="sorting"
                              tabIndex="0"
                              aria-controls="kt_table_1"
                              rowSpan="1"
                              colSpan="1"
                              style={{ width: "50px" }}
                              aria-label="Country: activate to sort column ascending"
                            >
                              {t("Destinataire")}
                            </th>
                            <th
                              className="sorting"
                              tabIndex="0"
                              aria-controls="kt_table_1"
                              rowSpan="1"
                              colSpan="1"
                              style={{ width: "50px" }}
                              aria-label="Country: activate to sort column ascending"
                            >
                              {t("Canal")}
                            </th>
                            <th
                              className="sorting"
                              tabIndex="0"
                              aria-controls="kt_table_1"
                              rowSpan="1"
                              colSpan="1"
                              style={{ width: "70.25px" }}
                              aria-label="Country: activate to sort column ascending"
                            >
                              {t("Contenu/message")}
                            </th>
                            <th
                              className="sorting"
                              tabIndex="0"
                              aria-controls="kt_table_1"
                              rowSpan="1"
                              colSpan="1"
                              style={{ width: "70.25px" }}
                              aria-label="Country: activate to sort column ascending"
                            >
                              {t("Date")}
                            </th>
                            <th
                              className="sorting"
                              tabIndex="0"
                              aria-controls="kt_table_1"
                              rowSpan="1"
                              colSpan="1"
                              style={{ width: "70.25px" }}
                              aria-label="Country: activate to sort column ascending"
                            >
                              {t("Statut")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {staffs.length ? (
                            showList ? (
                              showList.map((staff, index) =>
                                printBodyTable(staff, index)
                              )
                            ) : (
                              <EmptyTable search={true} />
                            )
                          ) : (
                            <EmptyTable />
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th rowSpan="1" colSpan="1">
                              {t("Nom")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {t("Téléphone")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {t("Email")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {t("Unité")}
                            </th>
                            {verifyPermission(
                              props.userPermissions,
                              "list-staff-from-any-unit"
                            ) ||
                              verifyPermission(
                                props.userPermissions,
                                "pilot-list-staff-from-any-unit"
                              ) ? (
                              <th rowSpan="1" colSpan="1">
                                {t("Institution")}
                              </th>
                            ) : (
                              <th style={{ display: "none" }} />
                            )}
                            <th rowSpan="1" colSpan="1">
                              {t("Position")}
                            </th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-5">
                      <div
                        className="dataTables_info"
                        id="kt_table_1_info"
                        role="status"
                        aria-live="polite"
                      >
                        {t("Affichage de")} {showList.length}{" "}
                        {t("sur")} {total} {t("données")}
                      </div>
                    </div>
                    {showList.length ? (
                      <div className="col-sm-12 col-md-7 dataTables_pager">
                        <Pagination
                          numberPerPage={numberPerPage}
                          onChangeNumberPerPage={onChangeNumberPerPage}
                          activeNumberPage={activeNumberPage}
                          onClickPreviousPage={(e) => onClickPreviousPage(e)}
                          pages={pages}
                          onClickPage={(e, number) => onClickPage(e, number)}
                          numberPage={numberPage}
                          onClickNextPage={(e) => onClickNextPage(e)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    ) : null
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    userPermissions: state.user.user.permissions,
    activePilot: state?.user?.user?.staff?.is_active_pilot || false,
    plan: state.plan.plan,
  };
};

export default connect(mapStateToProps)(ProofReceipt);
